var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.5 9H6c-.827 0-1.5-.673-1.5-1.5v-6C4.5.673 5.173 0 6 0h3.284c.297 0 .583.12.794.33l1.591 1.592c.211.21.331.497.331.794V7.5c0 .827-.673 1.5-1.5 1.5Zm-9-6h2.25v1.125H1.5a.376.376 0 0 0-.375.375v6c0 .206.169.375.375.375H6a.376.376 0 0 0 .375-.375v-.75H7.5v.75c0 .827-.673 1.5-1.5 1.5H1.5C.673 12 0 11.327 0 10.5v-6C0 3.673.673 3 1.5 3Z"
})));
export default SvgCopyIcon;